const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'ld_session_id';

export function getOrCreateSession() {
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if (!s) {
      s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return 'no-session';
  }
}

const post = (path, body) => fetch(`${API_URL}${path}`, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true,
}).catch(() => {});

export const trackQuoteForm = (event, field) => post('/api/track/quote-form', { session_id: getOrCreateSession(), event, field });

const tapKind = (href) => {
  if (href.startsWith('tel:')) return 'phone';
  if (/wa\.me|whatsapp\.com|^whatsapp:/i.test(href)) return 'whatsapp';
  return null;
};

export function handleTapClick(e) {
  const a = e.target.closest && e.target.closest('a[href]');
  if (!a || window.location.pathname.startsWith('/admin')) return;
  const href = a.getAttribute('href') || '';
  const kind = tapKind(href);
  if (!kind) return;
  post('/api/track/tap', {
    kind, href, label: (a.textContent || a.getAttribute('aria-label') || '').trim().slice(0, 120),
    path: window.location.pathname, referrer: document.referrer || '', session_id: getOrCreateSession(),
  });
}
